import { render, staticRenderFns } from "./PlanningCalendarItemComponent.vue?vue&type=template&id=64b1c627&scoped=true&"
import script from "./PlanningCalendarItemComponent.vue?vue&type=script&lang=js&"
export * from "./PlanningCalendarItemComponent.vue?vue&type=script&lang=js&"
import style0 from "./PlanningCalendarItemComponent.vue?vue&type=style&index=0&id=64b1c627&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b1c627",
  null
  
)

export default component.exports